import React from 'react'
import { legacyImageURL } from 'components/LegacyImage'
import PlaceholderImage from 'components/PlaceholderImage'

import './ColumnsSection.scss'

const ColumnsSection = ({ buttonLinks, layout, pqResultId, onLinkClick }) => (
  <>
    {buttonLinks.map((link, i) => {
      //check existence of dynamic rule to hide current link using pqresultid
      const hide =
        link.dynamics &&
        link.dynamics.some(dynamic => dynamic.value === pqResultId)
      const imageUrl = link.headerImage
        ? `${process.env.SITE_ASSET_URL}/${link.headerImage.id}`
        : ''

      if (!link.dynamics || !hide) {
        return (
          <div
            key={i}
            className={`column-single card-${layout !== 'ONE_COLUMN' || false}`}
          >
            <div className="column-inside">
              {layout !== 'ONE_COLUMN' && (
                <a
                  href={link.url}
                  key={i + '-a'}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    onLinkClick(link)
                  }}
                >
                  <div
                    className="referral-image"
                    style={{ backgroundImage: `url(${imageUrl})` }}
                  >
                    <PlaceholderImage
                      src={legacyImageURL(link.headerImage)}
                      height={400}
                      width={600}
                    />
                  </div>
                </a>
              )}
              <div className="referral-bottom">
                {(link.topText || link.bottomText) && (
                  <div className="description">
                    {link.topText && (
                      <span
                        dangerouslySetInnerHTML={{ __html: link.topText }}
                      ></span>
                    )}
                    {link.bottomText && (
                      <span
                        dangerouslySetInnerHTML={{ __html: link.bottomText }}
                      ></span>
                    )}
                  </div>
                )}
                {link.showButton === true && (
                  <a
                    href={link.url}
                    key={i + '-b'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="shop-btn"
                    style={{
                      background: link.buttonColor,
                      color: '#fff',
                    }}
                    onClick={() => {
                      onLinkClick(link)
                    }}
                  >
                    {link.buttonText}
                  </a>
                )}
              </div>
            </div>
          </div>
        )
      } else {
        return <></>
      }
    })}
  </>
)

export default ColumnsSection
